import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { configureStore as configureReduxStore, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit'

import { Reducers, reducers } from './reducers'

export const configureStore = async () => configureReduxStore({
    reducer: reducers,
    // RTK's dev-only serializability and immutability checks are left off to keep the behavior of the previous plain
    // Redux store (some state, like dates, isn't serializable and some legacy code mutates state).
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
    }),
    devTools: process.env.NODE_ENV !== 'production' && process.env.REACT_APP_APP_ENV !== 'production',
})

export type TypedDispatch = ThunkDispatch<Reducers, unknown, UnknownAction>
export type ReducerGetter = () => Reducers
export const useTypedDispatch = (): TypedDispatch => useDispatch<TypedDispatch>()
export const useTypedSelector: TypedUseSelectorHook<Reducers> = useSelector
